module.exports = __webpack_public_path__ + "img/17.ab92064a.png";